import { token } from '../../localStorage'
import { BASE_URL } from '../constants'

// Servicio para crear oferta por Hiring Advisor
export const createOfferHutritNextByHa = async (data) => {
  const URL = `${BASE_URL}hiring/companyAdministration/creationOfferHutritNext`
  const rawBody = JSON.stringify(data)

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return { response, res }
  } catch (error) {
    console.log(error)
    return { response: null, res: null, error }
  }
}
